module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Total Snowfall":"Précipitations de neige totales","Storm Snowfall":"Précipitations de neige par tempête","Snowfall Chart":"Graphique Des Précipitations de Neige"}}')
  delete Component.options._Ctor
}
